const mapTransformData = (Data, areaMapping = [], groupByKeys) => {
  // console.log(Data);
  const mapTransformedData = [];

  // Ensure areaMapping is an array before proceeding
  if (!Array.isArray(areaMapping)) {
    console.error("areaMapping should be an array", areaMapping);
    return { mapTransformedData: Data };
  }

  if (areaMapping.length === 0) return { mapTransformedData: Data };
  const responseKey = groupByKeys[0]?.responseKey;

  Data.forEach((dataRow) => {
    const currentValue = dataRow[responseKey];
    const targetObject = areaMapping.find(
      (item) => item.userArea === currentValue
    );
    // console.log(targetObject);
    const { viztaArea = [] } = targetObject || {};

    // console.log(viztaArea);

    viztaArea.forEach((areaUnit) => {
      const newDataObject = { ...dataRow, [responseKey]: areaUnit };
      mapTransformedData.push(newDataObject);
    });

    // console.log(currentValue, viztaArea);
  });

  // console.log(mapTransformedData);
  return { mapTransformedData };
};

export { mapTransformData };
